export class UpdateBackupPolicyRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "resourceSelector",
            "baseName": "resourceSelector",
            "type": "BackupPolicyResourceSelector",
            "format": ""
        },
        {
            "name": "backupPlan",
            "baseName": "backupPlan",
            "type": "BackupPolicyPlan",
            "format": ""
        },
        {
            "name": "scheduleMode",
            "baseName": "scheduleMode",
            "type": "ScheduleMode",
            "format": ""
        },
        {
            "name": "labels",
            "baseName": "labels",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateBackupPolicyRequest.attributeTypeMap;
    }
    constructor() {
    }
}
